module.exports = __webpack_public_path__ + "static/media/Branches.78500fca.md";